import { SearchBar } from "../../components/search/SearchBar";
import "./home.css";

export const HomePage = () => {
  return (
    <div className="container">
      <div className="logo-con">
        <img src="../../assets/logo.png" alt="logo" className="logo" />
      </div>
      <div className="search-div">
        <SearchBar />
      </div>
    </div>
  );
};
